var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background-component" },
    [
      _c(
        "div",
        { staticClass: "form-content" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.formData, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "颜色" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.formData.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "color", $$v)
                      },
                      expression: "formData.color",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            { attrs: { type: "success" }, on: { click: _vm.confirmSave } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览图片",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }